import styled from "styled-components";
import { CSSVars } from "@/styles/styles.config";

export const StyledDiv = styled.section`
  padding: 60px 20px;
  background: ${CSSVars.gray50};

  @media screen and (min-width: ${CSSVars.breakpointMD}) {
    padding: 80px 30px;
  }

  @media screen and (min-width: ${CSSVars.breakpointLG}) {
    padding: 100px 40px;
  }

  h2 {
    font-family: ${CSSVars.primaryFont};
    font-weight: 700;
    font-size: 28px;
    line-height: 1.2;
    color: ${CSSVars.black};
    text-align: center;
    margin: 0 auto 40px;
    max-width: 800px;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      font-size: 36px;
      margin-bottom: 50px;
    }

    @media screen and (min-width: ${CSSVars.breakpointLG}) {
      font-size: 44px;
      margin-bottom: 60px;
    }
  }

  .carousel-wrap {
    position: relative;
    max-width: 1280px;
    margin: 0 auto;
  }

  .track {
    display: flex;
    gap: 20px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding: 10px 4px 10px;
    scroll-behavior: smooth;

    /* Hide scrollbar */
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .card {
    flex: 0 0 260px;
    scroll-snap-align: start;
    background: ${CSSVars.white};
    border-radius: 16px;
    overflow: hidden;
    text-decoration: none;
    color: inherit;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    display: flex;
    flex-direction: column;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 20px rgba(76, 79, 255, 0.15);
    }

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      flex: 0 0 300px;
    }
  }

  .image-wrapper {
    width: 100%;
    height: 160px;
    overflow: hidden;
    background: ${CSSVars.gray50};
    flex-shrink: 0;

    img {
      width: 100% !important;
      height: 100% !important;
      object-fit: cover !important;
      display: block !important;
      max-width: none !important;
      max-height: none !important;
    }
  }

  .details {
    padding: 18px 20px 22px;
  }

  h3 {
    font-family: ${CSSVars.primaryFont};
    font-weight: 600;
    font-size: 18px;
    margin: 0 0 8px;
    color: ${CSSVars.black};
  }

  p {
    font-family: ${CSSVars.secondaryFont};
    font-weight: 300;
    font-size: 14px;
    line-height: 1.5;
    margin: 0;
    color: #555;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border: none;
    background: ${CSSVars.white};
    color: ${CSSVars.black};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.2s ease, background 0.2s ease, transform 0.15s ease;

    &:hover:not(:disabled) {
      background: ${CSSVars.blue500};
      color: ${CSSVars.white};
    }

    &:disabled {
      opacity: 0;
      pointer-events: none;
    }

    &.arrow-left {
      left: -8px;

      @media screen and (min-width: ${CSSVars.breakpointMD}) {
        left: -24px;
      }
    }

    &.arrow-right {
      right: -8px;

      @media screen and (min-width: ${CSSVars.breakpointMD}) {
        right: -24px;
      }
    }
  }
`;
